import React from 'react';

import { flagStyles } from '../settings';

const SvgGE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1848px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGE;
